export const status = Object.freeze({
    "NotStarted": 0,
    "InProgress": 1,
    "Pending": 2,
    "Submitted": 3,
    "Completed": 4,
    "PartialApproved": 5,
    "Approved": 6,
});